module.exports = __webpack_public_path__ + "static/media/mi9Retail.18fd2d57.JPG";